


$(document).ready(function() {


  
   if($('body').hasClass('page-products')) {
setTimeout(function() {
  var inquiryButton2 = $('<button class="inquiry-button btn btn_for_hover">Make an Inquiry</button>');

    $('.page-products .detail-page .detail-area').append(inquiryButton2);
inquiryButton2.click(function() {
 var buttonToClick2 = $('#header-make-an-enquiry');
                            buttonToClick2.click();
        var windowUrl2 = window.location.href;
        
        // Create input field with product details and window URL
        var inputField2 = '<input type="hidden" name="contact[product_details]" value="'+ windowUrl2 + '" class="form-control">';
        
        // Append input field to #contact_form inside #modal_global_enquiryform
        $('#modal_global_enquiryform #contact_form').append(inputField2);
    });

    $('#modal_global_enquiryform .close').click(function() {
        // Remove the last appended input field from #contact_form
        $('#modal_global_enquiryform #contact_form input[name="contact[product_details]"]:last-of-type').remove();
    });
       }, 8000);
     
  } 
  
  
  
  $('#header-make-an-enquiry').click(function(e) {
        // Get current window URL
        var windowUrl = window.location.href;
        
        // Create input field with product details and window URL
        var inputField = '<input type="hidden" name="contact[product_details]" value="'+ windowUrl + '" class="form-control">';
        
        // Append input field to #contact_form inside #modal_global_enquiryform
        $('#modal_global_enquiryform #contact_form').append(inputField);
    });

    $('#modal_global_enquiryform .close').click(function() {
        // Remove the last appended input field from #contact_form
        $('#modal_global_enquiryform #contact_form input[name="contact[product_details]"]:last-of-type').remove();
    });

  
if ($('body').hasClass('page-shop-diamonds')) {
    setTimeout(function() {
        $('.nivoda-grid__item').each(function() {
            $(this).off('click').on('click', function() { // Unbind click event before binding again
                setTimeout(function() {
                    if (!$('.inquiry-button').length) { // Check if .inquiry-button class does not exist
                        const inquiryButton = $('<button class="inquiry-button btn">Make an Inquiry</button>');
                        $('.detail-pop-up .description').append(inquiryButton); // Empty previous content before appending button
                        inquiryButton.on('click', function() {
                          
                            const buttonToClick = $('#header-make-an-enquiry');
                            buttonToClick.click();
                           const buttonToClick2 = $('.detail-pop-up .close.closePopup');
                            buttonToClick2.click();
                         
                         
                        
                        });

                        const removeclass = $('.modal-content .close');
                            removeclass.click();
                          $('#detail-pop-up').removeClass('active');
                      
                     var itemHref = $('.sc-fznMnq.dAmkg').attr('href');
                          var inputField1 = '<input type="hidden" name="contact[product_details]" value="'+ itemHref + '" class="form-control">';
        
        // Append input field to #contact_form inside #modal_global_enquiryform
        $('#modal_global_enquiryform #contact_form').append(inputField1);

      $('#modal_global_enquiryform .close').click(function() {
        // Remove the last appended input field from #contact_form
        $('#modal_global_enquiryform #contact_form input[name="contact[product_details]"]:last-of-type').remove();
    });
                        
                    }
                }, 500);
            });
        });
    }, 8000); // 8000 milliseconds = 8 seconds
}

  
});

document.addEventListener('DOMContentLoaded', function() {

  if($('body').hasClass('page-product.purchasable')) {
    setTimeout(function() {
      // Select all video elements on the page
      var videos = document.querySelectorAll('.pt-product-media-internal video');
      
      // Play each video
      videos.forEach(function(video) {
          video.play();
      });
    }, 3000);
  }
  
});
